module.exports = __webpack_public_path__ + "img/eleaf.3b38c5bb.png";